import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import EventIcon from 'components/material-symbol/icons/Event'
import { makeStyles } from '@material-ui/core/styles'
import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers'
import CustomLuxonAdapter from 'lib/CustomLuxonAdapter'
import {
  mergeDesktopDatePickerSlotProps,
  mergeDesktopDatePickerSlots,
} from 'components/pga-time-picker/desktop-date-picker'

const useStyles = makeStyles(theme => ({
  jumpButton: {
    fontWeight: 600,
    fontSize: '0.875rem',
    textTransform: 'none',
    color: theme.palette.text.primary,
    minWidth: 140,
    padding: theme.spacing(0.25, 1),
  },
}))

const hiddenPickerStyle = { display: 'none' }

/**
 * Clickable week/day label that opens a date picker to jump the schedule.
 */
function AcademyScheduleDateJump({ label, value, onJump }) {
  const classes = useStyles()
  const buttonRef = useRef(null)
  const [pickerOpen, setPickerOpen] = useState(false)

  const handleChange = picked => {
    if (picked?.isValid) {
      onJump(picked)
    }
    setPickerOpen(false)
  }

  if (!label) return null

  return (
    <>
      <Button
        ref={buttonRef}
        className={classes.jumpButton}
        startIcon={<EventIcon fontSize="small" />}
        onClick={() => setPickerOpen(true)}
        aria-label="Jump to date"
      >
        {label}
      </Button>
      <div style={hiddenPickerStyle} aria-hidden>
        <LocalizationProvider dateAdapter={CustomLuxonAdapter} locale="en-us">
          <DesktopDatePicker
            open={pickerOpen}
            value={value}
            onClose={() => setPickerOpen(false)}
            onChange={handleChange}
            format="MMM d, yyyy"
            closeOnSelect
            slots={mergeDesktopDatePickerSlots()}
            slotProps={mergeDesktopDatePickerSlotProps({
              textField: { sx: hiddenPickerStyle },
              popper: {
                disablePortal: false,
                anchorEl: () => buttonRef.current,
              },
            })}
          />
        </LocalizationProvider>
      </div>
    </>
  )
}

AcademyScheduleDateJump.propTypes = {
  label: PropTypes.string,
  value: PropTypes.object.isRequired,
  onJump: PropTypes.func.isRequired,
}

export default AcademyScheduleDateJump
